import { gql } from '@at/sauron-platform-graphql'

export const myAtSavedAdvertListQuery = gql`
    query SavedAdverts($channel: VehicleChannel) {
        user {
            databaseId
            name
            savedAdverts(channel: $channel) {
                results {
                    id
                    channel
                }
            }
        }
    }
`

export const myAtSaveAdvertMutation = gql`
    mutation AddOrDeleteSavedAdvert($addOrDeleteSavedAdvertInput: AddOrDeleteSavedAdvertInput!) {
        addOrDeleteSavedAdvertWithUserCheck(addOrDeleteSavedAdvertInput: $addOrDeleteSavedAdvertInput) {
            id
            isSaved
        }
    }
`
